module.exports = __webpack_public_path__ + "img/bs_silo_1.96f5127a.png";